(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["apps"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('gg-review-layout')) {
  customElements.define('gg-review-layout', class extends HTMLElement {
    static products = new Map();

    connectedCallback() {
      this.seenProducts = new WeakSet();
      this.layoutObserver = new ResizeObserver(() => this.measureHeader());
      this.resizeHandler = () => this.measureHeader();
      window.addEventListener('resize', this.resizeHandler);
      this.siteHeader = document.querySelector('.header-section');
      if (this.siteHeader) this.layoutObserver.observe(this.siteHeader);
      this.visibilityObserver = new IntersectionObserver(entries => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;
          this.visibilityObserver.unobserve(entry.target);
          const link = entry.target.matches('a') ? entry.target : entry.target.querySelector('.jdgm-product-name a');
          if (link) this.addProductDetails(link);
        }
      }, { rootMargin:'100px' });
      this.contentObserver = new MutationObserver(() => this.enhance());
      this.contentObserver.observe(this, { childList:true, subtree:true });
      this.enhance();
    }

    disconnectedCallback() {
      this.contentObserver?.disconnect();
      this.visibilityObserver?.disconnect();
      this.layoutObserver?.disconnect();
      window.removeEventListener('resize', this.resizeHandler);
    }

    measureHeader() {
      for (const [property, element] of [['--gg-review-header-height', this.reviewHeader], ['--gg-review-site-header-height', this.siteHeader]]) {
        if (!element) continue;
        const height = property === '--gg-review-site-header-height' && !['sticky', 'fixed'].includes(getComputedStyle(element).position) ? 0 : Math.ceil(element.getBoundingClientRect().height);
        const value = height + 'px';
        if (this.style.getPropertyValue(property) !== value) this.style.setProperty(property, value);
      }
      const headerHeight = parseFloat(this.style.getPropertyValue('--gg-review-header-height')) || 0;
      const siteHeaderHeight = parseFloat(this.style.getPropertyValue('--gg-review-site-header-height')) || 0;
      const ratio = parseFloat(getComputedStyle(this).getPropertyValue('--gg-review-image-ratio')) || 1;
      const imageHeight = Math.max(0, Math.floor(Math.min((document.documentElement.clientWidth * 0.8 - 2) / ratio, window.innerHeight - siteHeaderHeight - headerHeight - 300)));
      const value = imageHeight + 'px';
      if (this.style.getPropertyValue('--gg-review-mobile-image-height') !== value) this.style.setProperty('--gg-review-mobile-image-height', value);
    }

    enhance() {
      const header = this.querySelector('.jdgm-header');
      const description = this.querySelector('template[data-review-description]');
      if (header && description && !header.querySelector('.gg-review-description')) {
        header.append(description.content.cloneNode(true));
      }
      if (header && header !== this.reviewHeader) {
        if (this.reviewHeader) this.layoutObserver.unobserve(this.reviewHeader);
        this.reviewHeader = header;
        this.layoutObserver.observe(header);
        this.measureHeader();
      }
      for (const link of this.querySelectorAll('.jdgm-product-name a')) {
        if (this.seenProducts.has(link) || link.querySelector('.gg-review-product-info')) continue;
        this.seenProducts.add(link);
        this.visibilityObserver.observe(link.closest('.jdgm-card') || link);
      }
    }

    async addProductDetails(link) {
      const url = new URL(link.href, location.origin);
      if (url.origin !== location.origin || !/\/products\/[^/]+\/?$/.test(url.pathname)) return;
      const productUrl = url.pathname.replace(/\/$/, '') + '.js';
      if (!this.constructor.products.has(productUrl)) {
        this.constructor.products.set(productUrl, fetch(productUrl, { headers:{ Accept:'application/json' } })
          .then(response => response.ok ? response.json() : null)
          .catch(() => null));
      }
      const product = await this.constructor.products.get(productUrl);
      if (!product || !link.isConnected || link.querySelector('.gg-review-product-info')) return;
      const details = document.createElement('span');
      details.className = 'gg-review-product-info';
      const title = document.createElement('span');
      title.className = 'gg-review-product-title';
      title.textContent = link.textContent;
      details.append(title);
      if (typeof product.price === 'number' && this.dataset.currency) {
        const price = document.createElement('span');
        price.className = 'gg-review-product-price';
        price.textContent = new Intl.NumberFormat(this.dataset.locale || 'en', { style:'currency', currency:this.dataset.currency }).format(product.price / 100);
        details.append(price);
      }
      link.replaceChildren(details);
      if (product.featured_image) {
        const image = document.createElement('img');
        image.className = 'gg-review-product-image';
        const imageUrl = new URL(product.featured_image, location.origin);
        imageUrl.searchParams.set('width', '96');
        image.src = imageUrl.href;
        image.alt = '';
        image.width = 48;
        image.height = 48;
        image.loading = 'lazy';
        link.prepend(image);
      }
    }
  });
}

(() => {
  if (window.ggReviewViewerInstalled) return;
  window.ggReviewViewerInstalled = true;
  const enhance = () => {
    const dialog = document.querySelector('.jdgm-modal__content[aria-label="Media Gallery"]');
    const carousel = dialog?.querySelector('.jm-carousel');
    if (!carousel || carousel.querySelector('.gg-review-nav')) return;
    for (const [direction, label, icon] of [[-1, 'Previous review', '‹'], [1, 'Next review', '›']]) {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'gg-review-nav gg-review-nav--' + (direction < 0 ? 'previous' : 'next');
      button.setAttribute('aria-label', label);
      button.textContent = icon;
      button.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        const currentId = dialog.querySelector('.jm-review-item[review-uuid]')?.getAttribute('review-uuid');
        const cards = Array.from(document.querySelectorAll('.jdgm-cards-carousel .jdgm-card[data-review-id]:not([data-clone-type])'));
        const index = cards.findIndex(card => card.dataset.reviewId === currentId);
        if (index < 0 || cards.length < 2) return;
        const next = cards[(index + direction + cards.length) % cards.length];
        dialog.querySelector('button[aria-label="Close"]')?.click();
        setTimeout(() => next.click(), 250);
      });
      carousel.append(button);
    }
  };
  new MutationObserver(enhance).observe(document.body, { childList:true, subtree:true });
  enhance();
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gg-hero-slideshow"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gg-hero-slideshow')) {
    customElements.define('gg-hero-slideshow',class extends HTMLElement {
      connectedCallback() {
        this.slides=Array.from(this.querySelectorAll('[data-slide]'));
        if(this.slides.length<2) return;
        this.current=0;
        this.abortController=new AbortController();
        const options={signal:this.abortController.signal};
        this.reduced=matchMedia('(prefers-reduced-motion: reduce)');
        this.paused=this.dataset.autoplay!=='true'||this.reduced.matches;
        this.pauseButton=this.querySelector('[data-pause]');
        this.updatePause=()=>{ this.pauseButton.textContent=this.paused?'▶':'Ⅱ'; this.pauseButton.setAttribute('aria-label',this.paused?this.pauseButton.dataset.playLabel:this.pauseButton.dataset.pauseLabel); };
        this.show=(index)=>{this.current=(index+this.slides.length)%this.slides.length;this.slides.forEach((slide,slideIndex)=>{const active=slideIndex===this.current;slide.classList.toggle('is-active',active);slide.setAttribute('aria-hidden',String(!active));});this.querySelector('[data-counter]').textContent=(this.current+1)+' / '+this.slides.length;};
        this.stop=()=>clearInterval(this.timer);
        this.start=()=>{this.stop();if(!this.paused&&!document.hidden&&!this.matches(':hover')&&!this.contains(document.activeElement)){this.timer=setInterval(()=>this.show(this.current+1),Number(this.dataset.delay)||5000);}};
        this.querySelector('[data-next]').addEventListener('click',()=>{this.show(this.current+1);this.start();},options);
        this.querySelector('[data-prev]').addEventListener('click',()=>{this.show(this.current-1);this.start();},options);
        this.pauseButton.addEventListener('click',()=>{this.paused=!this.paused;this.updatePause();this.start();},options);
        this.addEventListener('mouseenter',this.stop,options);
        this.addEventListener('mouseleave',this.start,options);
        this.addEventListener('focusin',this.stop,options);
        this.addEventListener('focusout',()=>requestAnimationFrame(this.start),options);
        document.addEventListener('visibilitychange',this.start,options);
        this.reduced.addEventListener('change',()=>{if(this.reduced.matches){this.paused=true;this.updatePause();this.stop();}},options);
        document.addEventListener('shopify:block:select',event=>{const selected=this.slides.findIndex(slide=>slide===event.target||slide.contains(event.target));if(selected>=0){this.show(selected);this.paused=true;this.updatePause();this.stop();}},options);
        this.updatePause();this.start();
      }
      disconnectedCallback(){clearInterval(this.timer);this.abortController?.abort();}
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gg-video-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gg-video-carousel')) {
    customElements.define('gg-video-carousel', class extends HTMLElement {
      connectedCallback() {
        this.abortController = new AbortController();
        const options = { signal: this.abortController.signal };
        const track = this.querySelector('.gg-videos__track');
        const autoButton = this.querySelector('[data-auto-scroll]');
        if (autoButton) {
          autoButton.addEventListener('click', () => {
            const paused = autoButton.getAttribute('aria-pressed') !== 'true';
            autoButton.setAttribute('aria-pressed', String(paused));
            autoButton.setAttribute('aria-label', paused ? autoButton.dataset.resumeLabel : autoButton.dataset.pauseLabel);
            autoButton.textContent = paused ? '▶' : 'Ⅱ';
          }, options);
          this.autoScrollTimer = setInterval(() => {
            if (document.hidden || matchMedia('(prefers-reduced-motion: reduce)').matches || this.matches(':hover, :focus-within') || autoButton.getAttribute('aria-pressed') === 'true' || [...this.querySelectorAll('video')].some(video => !video.paused && !video.muted)) return;
            const card = track.querySelector('.gg-videos__card');
            if (!card || track.scrollWidth <= track.clientWidth + 2) return;
            const atEnd = Math.abs(track.scrollLeft) >= track.scrollWidth - track.clientWidth - 2;
            const direction = getComputedStyle(track).direction === 'rtl' ? -1 : 1;
            if (atEnd) track.scrollTo({ left: 0, behavior: 'smooth' });
            else track.scrollBy({ left: (card.getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap)) * direction, behavior: 'smooth' });
          }, Number(autoButton.dataset.interval) * 1000);
        }
        this.videoObserver = new IntersectionObserver(entries => entries.forEach(entry => {
          const video = entry.target;
          video.dataset.visible = String(entry.isIntersecting && entry.intersectionRatio >= .2);
          if (video.dataset.visible !== 'true') video.pause();
          else if (!document.hidden && video.dataset.userPaused !== 'true') video.play().catch(() => {});
        }), { threshold: .2 });
        this.querySelectorAll('video').forEach(video => {
          const playButton = video.parentElement.querySelector('.gg-videos__play');
          const playLabel = playButton.getAttribute('aria-label');
          video.controls = false;
          video.muted = true;
          const updatePlayback = () => {
            playButton.classList.toggle('is-playing', !video.paused);
            playButton.querySelector('span').textContent = '▶';
            playButton.setAttribute('aria-label', playLabel);
          };
          playButton.addEventListener('click', () => {
            video.dataset.userPaused = String(!video.paused);
            if (video.paused) video.play().catch(updatePlayback);
            else video.pause();
          }, options);
          video.addEventListener('play', () => {
            updatePlayback();
          }, options);
          video.addEventListener('pause', updatePlayback, options);
          video.addEventListener('ended', updatePlayback, options);
          updatePlayback();
          this.videoObserver.observe(video);
        });
        document.addEventListener('visibilitychange', () => {
          this.querySelectorAll('video').forEach(video => {
            if (document.hidden) video.pause();
            else if (video.dataset.visible === 'true' && video.dataset.userPaused !== 'true') video.play().catch(() => {});
          });
        }, options);
      }
      disconnectedCallback() {
        clearInterval(this.autoScrollTimer);
        this.abortController?.abort();
        this.videoObserver?.disconnect();
        this.querySelectorAll('video').forEach(video => video.pause());
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
